import React from 'react';

const Div = ({ config }) => {
  return (
    <div
      id={config.variable}
      name={config.variable}
      className={(config.visible === undefined || config.visible) ? config.classContainer : "div-hidden"}
    >
      {config.value}
    </div>
  )
}

export default Div;
